import { render, staticRenderFns } from "./SpecialtySelect.vue?vue&type=template&id=6b070b7b&"
import script from "./SpecialtySelect.vue?vue&type=script&lang=js&"
export * from "./SpecialtySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports